<template>
  <div class="container-fluid">
    <b-card>
      <template #header>
        <h6 class="mb-0">Upload Kelulusan PSB</h6>
      </template>
      <span
        >Buatkan data yang terdiri dari kolom (noregist,va,nis) copy dari data
        excel</span
      >
      <div class="row">
        <div class="col-md-4">
          <b-form-textarea
            v-model="data"
            rows="17"
            class="pr-4 mb-2"
            style="font-size: 13px"
            placeholder="isikan data (noregist,va,nis) pisahkan dengan tab"
          />
          #{{ result.length }} <br />
          <b-button size="sm" @click="getdata()">Cek Data</b-button>
          <b-button
            size="sm"
            @click="setkelulusan"
            class="ml-2"
            :disabled="result.length == 0"
            >Set Kelulusan</b-button
          >
        </div>

        <div class="col-md">
          <b-table
            :items="result"
            :fields="['no', 'noregist', 'nama', 'asalsekolah', 'nis', 'nova']"
            small
            style="font-size: 12px"
            :busy="isbusy"
            :tbody-tr-class="() => ({ style: 'height: 36px' })"
            sticky-header="500px"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(no)="row">
              {{ row.index + 1 }}
            </template>
          </b-table>
        </div>
      </div>
    </b-card>
    <b-card>
      <b-button size="sm" @click="getdatalulus">Cek Data Kelulusan</b-button>
      <b-button
        size="sm"
        @click="kirimDataSatuPerSatu"
        class="ml-2"
        :disabled="datalulus.length == 0"
        >Transfer to Data Siswa</b-button
      >
      <span class="ml-2">Total Transfer: {{ jmltransfer }}</span>
      <b-progress
        :value="value"
        :max="datalulus.length"
        show-progress
        animated
        class="mt-2"
      ></b-progress>
      <b-table
        class="mt-2"
        :items="datalulus"
        :fields="[
          'no',
          'nova',
          'noregist',
          'nama',
          'asalsekolah',
          'nisn',
          'ready',
          'transfer',
        ]"
        small
        style="font-size: 12px"
        :busy="isbusy"
        :tbody-tr-class="() => ({ style: 'height: 36px' })"
        sticky-header="500px"
      >
        <template #cell(nova)="row">
          {{ row.item.nova }}
          <span>
            <b-icon-arrow-right-square
              v-show="row.item.ready !== 'ready'"
              style="cursor: pointer"
              title="Transfer "
              @click="setready(row.item.nova, row.index)"
            />
          </span>
        </template>

        <template #cell(no)="row">
          {{ row.index + 1 }}
        </template>
      </b-table>
    </b-card>
    contoh browsetable.vue
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Uploadkelulusan",
  components: {},
  data() {
    return {
      data: "",
      dataArray: [],
      result: [],
      datalulus: [],
      isbusy: false,
      value: 0,
      jmltransfer: 0,
    };
  },
  methods: {
    async setready(nova, no) {
      await axios
        .post(
          this.$appUrl +
            "transferkelulusan.php?token=" +
            this.$globalData.Token +
            "&nova=" +
            nova
        )
        .then((res) => {
          if (res.data == "Sukses") {
            this.datalulus[no].transfer = "sukses";
            this.datalulus[no].ready = "ready";
            this.jmltransfer++;
          } else {
            this.datalulus[no].transfer = "gagal";
          }
        });
    },
    cari(kode) {
      // console.log('cari', kode)
      const result = this.dataArray.find((item) => item.nova === kode);
      return result ? result.nis : null; // Jika ditemukan, return nova, jika tidak return null
    },
    getdatalulus() {
      this.value = 0;
      this.jmltransfer = 0;
      axios
        .get(this.$appUrl + "getdatalulus.php?token=" + this.$globalData.Token)
        .then((res) => {
          this.datalulus = res.data;
          // console.log('datalulus', this.datalulus)
        });
    },
    getdata() {
      let rows = this.data.split("\n");
      this.result = [];
      this.isbusy = true;
      // Mengubah setiap baris menjadi objek {kode, nova}
      this.dataArray = rows.map((row) => {
        let [kode, nova, nis] = row.split("\t"); // Pisahkan kolom dengan tab
        return { kode, nova, nis };
      });

      // console.log(this.dataArray);
      axios
        .post(
          this.$appUrl + "cekkelulusan.php?token=" + this.$globalData.Token,
          this.dataArray
        )
        .then((res) => {
          this.result = res.data;
          this.result.forEach((element) => {
            // console.log('element', element)
            element.nis = this.cari(element.nova);
          });
          this.isbusy = false;
        });
    },
    async kirimDataSatuPerSatu() {
      for (let i = 0; i < this.datalulus.length; i++) {
        try {
          this.value = i + 1; // Update progress value
          if (this.datalulus[i].ready !== "ready") {
            const response = await axios.post(
              this.$appUrl +
                "transferkelulusan.php?token=" +
                this.$globalData.Token +
                "&nova=" +
                this.datalulus[i].nova,
              {
                nis: this.datalulus[i].nova,
                nama: this.datalulus[i].nama,
              }
            );

            if (response.data == "Sukses") {
              this.datalulus[i].transfer = "sukses";
              this.datalulus[i].ready = "ready";
              this.jmltransfer++;
            } else {
              this.datalulus[i].transfer = "gagal";
            }
          }
        } catch (error) {
          this.datalulus[i].status = "error";
          console.error(
            "Gagal kirim data untuk",
            this.datalulus[i].nova,
            error
          );
        }
      }
    },

    transfer() {
      axios
        .post(
          this.$appUrl + "transferkelulusan.php?token=" + this.$globalData.Token
        )
        .then((res) => {
          this.$bvModal.msgBoxOk("Transfer " + res.data);
        });
    },
    setkelulusan() {
      axios
        .post(
          this.$appUrl + "setkelulusan.php?token=" + this.$globalData.Token,
          this.dataArray
        )
        .then((res) => {
          this.$bvModal.msgBoxOk("Set kelulusan done " + res.data);
        });
    },
  },
};
</script>
